// Quick View
if(window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65') == -1) {
$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});
function processCart(var_id, qty) {
  jQuery.post('/cart/add.js', {
    quantity: qty,
    id: var_id
  }, null, "json").done(function () {
    window.ajaxCart.load();
    $(".fancybox-item.fancybox-close").click();
    $(".js-cart-trigger").click();

    $('.qv-add-to-cart-response').addClass('success').html('<span>Product has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
  })
  .fail(function ($xhr) {
    var data = $xhr.responseJSON;
    $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
  });
}
function quickView() {
    
  
  
  
  
  $(document).on("click", ".qv-add-button", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
    		let product_handle = $('#quick-view').attr("data-product_handle");
          $('#quick-view [data-select_radio]').each(function (i, e) {
            if (selectedOptions == '') {
              selectedOptions = $(e).find('[type="radio"]:checked').val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(e).find('[type="radio"]:checked').val();
            }
          });
          console.log(selectedOptions);
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart(var_id ,qty);
              }
            });
          });
         
        });
  
  
  	$(document).on("change", '#quick-view [data-select_radio] [type="radio"]', function () {
      console.log($(this));
      var selectedOptions = '';
      let product_handle = $('#quick-view').attr("data-product_handle");
      $('#quick-view [data-select_radio] [type="radio"]:checked').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
//       console.log(selectedOptions);
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            $('.qv-product-price').text('$' + price);
            
            let save_price = parseFloat(original_price - price).toFixed(2)
            if(original_price > 1) {
            	$('.qv-product-original-price').text('$' + original_price).show();
              	$('.qv-product-save-price > span').text('$' + save_price);
              	$('.qv-product-save-price').show();
            } else {
            	$('.qv-product-original-price').text('$' + original_price).hide();
              	$('.qv-product-save-price > span').text('$' + save_price);
              	$('.qv-product-save-price').hide();
            }
            if (v_inv == null) {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else {
              if (v.inventory_quantity < 1) {
                $('.qv-add-button').prop('disabled', true).val('Sold Out');
              } else {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              }
            }
            
            let image_embed = '<div><img src="' + v.featured_image.src + '"></div>';
          	image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          	$('.qv-product-images').html(image_embed);
            
          }
        });
      });
    });
  
  
  $(".quick-view").click(function () {
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    $('#quick-view').attr("data-product_handle", product_handle);

    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);
      var imageCount = $(images).length;
      console.log(product);
//       console.log(images);
      /*
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);

          $('.qv-product-images').slick({
            'dots': false,
            'arrows': true,
            prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0815/1831/t/44/assets/right-arrow_1.png?v=1626243864'>",
    		nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0815/1831/t/44/assets/right-arrow.png?v=1626243846'>",
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');

        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });
      */
      $('[data-variant_data]').html(JSON.stringify(variants));
      if(variants.length > 1) {
          image_embed = '<div><img src="' + variants[0].featured_image.src + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').html(image_embed);
        	$('.qv-product-images').css('opacity', 1);
      }
      /*$(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        $(option.values).each(function (i, value) {
          $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        });
      });*/
      
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><div data-select_radio class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
        $(option.values).each(function (i, value) {
          let selected = "";
          let selected_class = "";
          if(i == 0) {
          	selected = "checked";
            selected_class = "swatch_color_cm";
          }
          $('.option.' + opt.toLowerCase()).append('<label class="'+selected_class+'"><input type="radio" name="option_'+opt.toLowerCase()+'" value="' + value + '" '+selected+'>' + value + '</label>');
        });
      });
//       console.log(product.variants);
	  $(product.variants).each(function (i, v) {
//         console.log(i);
        if (v.inventory_quantity == 0) {
          $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.qv-product-price').text('$' + price);
          let save_price = parseFloat(original_price - price).toFixed(2);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
            $('.qv-product-save-price > span').text('$' + save_price);
            $('.qv-product-save-price').show();
          } else {
            $('.qv-product-original-price').hide();
            $('.qv-product-save-price > span').text('$' + save_price);
            $('.qv-product-save-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
      
//       console.log(product);
      
      var username="pubkey-aKeVLM50dbt551z8zOyXd079PWWwuu";
      var password="key-F1ypQKp6V979nxJKtrJ7U32mX3F5eD";
      
//       request_data ={
//         "productIds": [
//           {
//               "productId": "4024388163"
//           }
//         ]
//       }
      request_data = {
        "productIds": [
            {
                "productId": product.id,
                "productSKU": "",
                "productType": "",
                "productTitle": ""
            }
            ],
            "apiKey": username,
            "storeUrl": Shopify.shop
      };
            

      
      
      
      
      var settings = {
        "url": "https://stamped.io/api/widget/badges",
        "method": "POST",
        "data": request_data,
        "timeout": 0,
        "headers": {
          "Content-Type": "application/x-www-form-urlencoded",
          "Authorization": "Basic " + btoa(username + ":" + password)
        },
      };

      $.ajax(settings).done(function (response) {
        let rating = Math.ceil(response[0]["rating"]);
        let rating_html = '';
        for(i = 0; i < rating; i++) {
        	rating_html += '<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>';
        }
        let html = '<span class="stamped-product-reviews-badge">\
                        <span class="stamped-badge">\
                            <span class="stamped-starrating stamped-badge-starrating" aria-hidden="true">\
                                '+rating_html+'\
                            </span>\
                            <span class="stamped-badge-caption" data-reviews="262" data-rating="4.8" data-label="reviews" aria-label="262 reviews" data-version="2">\
                                '+response[0]["count"]+'<span style="display:none;"> reviews</span>\
                            </span>\
                        </span>\
                    </span>'
        $('[data-review]').html(html);
      });

      
      
    });

    
    
    
    //$(document).on("change", "#quick-view select", function () {
    
    
    
    
    $.fancybox({
      href: '#quick-view',
      maxWidth: 700,
      maxHeight: 350,
      fitToView: true,
      height: '64%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
        
        
      }
    });
    
    
    
    
    
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});}


